module.exports = __webpack_public_path__ + "static/media/dark-submenu-comparacao.24226c47.svg";